<template>
  <div id="app">
    <div class="titlebox">申请加入成都三明商会</div>
    <div class="mainbox">
      <div class="beftBox">
        <div class="mianTitle">基础信息</div>
        <div class="celeBox">
          <div class="celeBoxLeft">电话</div>
          <div class="celeBoxRight">
            <van-field
              style="color:#6c6d6f"
              input-align="right"
              v-model="value"
              placeholder="请输入用户名"
            />
          </div>
        </div>
        <div class="celeBox2">
          <div class="celeBoxLeft2">头像</div>

          <van-image width="80" height="80" src="https://img01.yzcdn.cn/vant/cat.jpeg" />
          <!-- </div> -->
        </div>
        <div class="celeBox">
          <div class="celeBoxLeft">姓名</div>
          <div class="celeBoxRight">
            <van-field
              style="color:#6c6d6f"
              input-align="right"
              v-model="value2"
              placeholder="请输入姓名"
            />
          </div>
        </div>
        <div class="celeBox">
          <div class="celeBoxLeft">申请职位</div>
          <div class="celeBoxRight">
            <van-field
              style="color:#6c6d6f"
              input-align="right"
              v-model="value3"
              @focus="show2=true"
              placeholder="请选择申请职位(选填)"
            />
          </div>
        </div>
        <div class="celeBox">
          <div class="celeBoxLeft">所属分支机构</div>
          <div class="celeBoxRight">
            <van-field
              style="color:#6c6d6f"
              input-align="right"
              v-model="value4"
              @focus="show=true"
              placeholder="请选择所属分支机构(选填)"
            />
          </div>
        </div>
        <div class="celeBox">
          <div class="celeBoxLeft">推荐人</div>
          <div class="celeBoxRight">
            <van-field
              style="color:#6c6d6f"
              input-align="right"
              v-model="value5"
              placeholder="推荐人姓名(必填)"
            />
          </div>
        </div>
        <div class="showsfz">
          <div class="showsfzTitle">上传身份证件(仅用于商会审核，不对外展示)</div>
          <div class="showsfzMain">
            <van-uploader>
              <van-image width="150" height="150" src="https://moodsci.com/business/sfz1.png" />
              <!-- <van-button  type="primary">上传文件</van-button> -->
            </van-uploader>
            <van-uploader>
              <van-image
                width="150"
                height="100"
                style="position: relative;top:25px"
                src="https://moodsci.com/business/sfz2.png"
              />
              <!-- <van-button  type="primary">上传文件</van-button> -->
            </van-uploader>
          </div>
        </div>
        <div class="showsfz">
          <div class="showsfzTitle">公司信息</div>
          <div class="showsfzMain">
            <van-uploader>
              <div
                style="width:80vw;height:150px; background-color: white;display: flex;
                  justify-content:center;
                    align-items: center; box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.2)"
              >
                <van-image width="50" height="50" src="https://moodsci.com/business/upload.png" />
              </div>

              <!-- <van-button  type="primary">上传文件</van-button> -->
            </van-uploader>
          </div>
        </div>
      </div>
      <div class="submitBox">
        <van-checkbox v-model="checked" style="margin-left:5vw">
          请阅读并同意
          <span style="color:#2A80FC">《成都三明商会入会协议》</span>
        </van-checkbox>

        <div class="btnbox">提交申请</div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom">
      <div style="height:30vh">
        <van-picker
          title="标题"
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
        />
      </div>
    </van-popup>
    <van-popup v-model="show2" position="bottom">
      <div style="height:30vh">
        <van-picker
          title="标题"
          show-toolbar
          :columns="columns2"
          @confirm="onConfirm2"
          @cancel="onCancel2"
          @change="onChange2"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Uploader } from "vant";

Vue.use(Uploader);
export default {
  data() {
    return {
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华", "衢州"],
      columns2: ["岗位1", "岗位2", "岗位3"],
      show: false,
      show2: false,
      value: "18282789369",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      checked: false
    };
  },
  methods: {
    onConfirm(e) {
      this.show = false;
      this.value4 = e;
    },
    onChange() {
      // this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onConfirm2(e) {
      this.show2 = false;
      console.log(e);
      this.value3 = e;
    },
    onChange2() {
      // this.show = false;
    },
    onCancel2() {
      this.show2 = false;
      console.log(2121);
    }
  }
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  width: 100vw;
  height: 100vh;
  /* background-color: #2750fc; */
  background-image: url("./assets/260.jpg");
}
.titlebox {
  height: 120px;
  width: 100%;
  /* background-color: aqua; */
  text-align: center;
  line-height: 50px;
  color: white;
}
.mainbox {
  height: 120vh;
  width: 100%;
  background-color: #f6f6fb;
  border-radius: 20px 20px 0px 0px;
  position: relative;
}
.mainbox::before {
  content: "";
  width: 80%;
  height: 30%;
  background-color: #a8b7fd;
  position: absolute;
  top: -40px;
  left: 10%;
  border-radius: 10px 10px 0 0;
}
.beftBox {
  width: 90%;
  padding: 10px 20px;
  /* height: 100%; */
  background-color: white;
  position: relative;
  z-index: 999;
  left: 5%;
  top: -30px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 10px 0 rgba(0, 0, 0, 0.19);
}
.mianTitle {
  height: 40px;
  width: 100%;
  /* background-color: #2750fc; */
  line-height: 40px;
  font-size: 20px;
  font-weight: 700;
}
.celeBox {
  height: 50px;
  width: 100%;
  border-bottom: 1px solid #6c6d6f85;
  color: #6c6d6f;
  /* background-color: #2750fc; */
  display: flex;
  justify-content: space-between;
}
.celeBox2 {
  height: 100px;
  width: 100%;
  border-bottom: 1px solid #6c6d6f;
  color: #6c6d6f;
  /* background-color: #2750fc; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.celeBoxLeft {
  height: 100%;
  width: 30%;
  /* background-color: #6c6d6f; */
  color: #6c6d6f;
  line-height: 50px;
  font-size: 15px;
}
.celeBoxLeft2 {
  height: 100%;
  width: 30%;
  /* background-color: #6c6d6f; */
  color: #6c6d6f;
  line-height: 100px;
  font-size: 15px;
}
.celeBoxRight {
  height: 100%;
  width: 70%;
  /* background-color: #2750fc; */
  line-height: 50px;
}
.celeBoxRight2 {
  /* height: 100%; */
  /* width: 50%; */
  /* background-color: #2750fc; */
  /* line-height: 50px; */
  display: flex;
  align-items: center;
}
.showsfz {
  height: 200px;
  width: 100%;
  /* background-color: red; */
}
.showsfzTitle {
  height: 30px;
  width: 100%;
  color: #6c6d6f;
  margin-top: 10px;
  line-height: 30px;
}
.showsfzMain {
  height: 170px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* background-color: #2750fc; */
}
.submitBox {
  /* position: absolute;
  top: 95vh; */
}
.btnbox {
  height: 60px;
  width: 90vw;
  border-radius: 30px;
  /* background-color: #2750fc; */
  background-image: linear-gradient(to right, #1c8efb, #2943fc);
  margin-left: 5vw;
  text-align: center;
  line-height: 60px;
  color: white;
  margin-top: 20px;
}
</style>
